module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/college-store/university-of-idaho-438991b608d36ddb984519bfb2dca77e.jpg";